import React from 'react';

const PackageModal = ({ package: pkg, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-gray-800 rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-start mb-6">
            <div>
              <h2 className="text-2xl font-bold mb-2">{pkg.name}</h2>
              <div className="text-blue-400 text-lg font-semibold">{pkg.speed}</div>
            </div>
            <button 
              onClick={onClose}
              className="text-gray-400 hover:text-white text-2xl"
            >
              ×
            </button>
          </div>

          <div className="space-y-6">
            <p className="text-gray-400">{pkg.description}</p>
            
            <div>
              <h3 className="text-lg font-semibold mb-4">Semua Fitur</h3>
              <div className="space-y-3">
                {pkg.features.map((feature, i) => (
                  <div key={i} className="flex items-center">
                    <div className="feature-icon mr-3 text-white">
                      {feature.icon}
                    </div>
                    <span className="text-gray-300">{feature.name}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Spesifikasi Teknis</h3>
              <div className="space-y-3">
                {Object.entries(pkg.specs).map(([key, value], i) => (
                  <div key={i} className="flex justify-between">
                    <span className="text-gray-400">{key}:</span>
                    <span className="text-white font-semibold">{value}</span>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-lg font-semibold mb-4">Ideal Untuk</h3>
              <div className="flex flex-wrap gap-2">
                {pkg.ideal.map((use, i) => (
                  <span key={i} className="bg-blue-600 text-white px-3 py-1 rounded-full text-sm">
                    {use}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-4 mt-8">
            <button className="flex-1 bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-xl font-semibold transition-colors">
              Mulai Free Trial
            </button>
            <button 
              onClick={onClose}
              className="flex-1 border border-gray-600 text-gray-300 hover:text-white hover:border-gray-500 py-3 rounded-xl font-semibold transition-colors"
            >
              Tutup
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageModal;